/*
ABOUT >>
THIS INPUT USED FOR CREATE BUTTON ON LIST AND WHEN CLICK ON BUTTON THEN CREATE POPUP AND RENDER LIST ACCORDING TO ROUTE
FULLY DYNAMIC  

ACTIVE >>
ITS IN RUNNING POSITION 

UPDATES >>
IT WILL BE UPDATE TO MAKE MORE ENHANCE CODE 
*/

import React ,{useState} from 'react';
import SecurityService from  '../security/security.service.js'
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import './dynamic-v-5.scss'
import SecureComponent  from '../security/secure.component.js';

// import Shop from '../shop/shop';

import YarnPurchaseContractDeliveryScheduleList from '../yarn-contract-delivery-schedule/yarn-contract-delivery-schedule-list.js'
import FabricPurchaseContractDeliveryScheduleList from '../fabric-purchase-contract-delivery-schedule/fabric-purchase-contract-delivery-schedule-list.js'
import ProjectionPlanning from '../projection-planning/projection-planning-list.js'
import GetBills from '../voucher/voucher-get-bills.js'
// import GetBills from '../voucher/get-bills.js'
// import BrandVendor from '../brand-vendor/brand-vendor';
// import UnitOfMeasurement from '../unit-of-measurement/unit-of-measurement';
const IrtizaDynamicListButtonDialog = (props) => {
    console.log(props)
    const [showAddNewDialog, setShowAddNewDialog] = useState(false);
    const [dialogType, setDialogType] = useState('');
    const [addNewClicked, setAddNewClicked] = useState(false); 

    const onAddNewClick = (type) => {
        console.log('type: ', type);
        if(type !== ''){
          setAddNewClicked(true)
          setShowAddNewDialog(false);
          setDialogType(type);
          setTimeout(() => { 
            setShowAddNewDialog(true);
          },100)
        }
      };

      const header = () => {
        console.log(props)
        if(showAddNewDialog) {
          return <div className="dialog-header heading" >
            {SecurityService.canUserAccess(props.Security)['List'] ? props.InputTitle:null}
            </div>;
        }
        else {
          return <div></div>;
        }
      };
    
      const onClose = () => {
        setAddNewClicked(false)
        setShowAddNewDialog(false);
        switch(dialogType){
          case 'ProducdtCategory':
            props.OnClosed()
          break;
          default:
            props.OnClosed()
          break;
        } 
      }
    
      const footerTemplate = () => {
        if(showAddNewDialog){
          return (<div id={props.Route}>
            <button id="btnSave"  className={`e-control e-btn e-primary ${props.Route}`} data-ripple="true" onClick={onClose}>Close</button>
          </div>);
        }
        else{<h3 style={{ textAlign:'center', width: '80%' }}></h3>
           return (<></>);
        }
      };
    
      const contentTemplate = (prop) => {
        console.log('props: ', props);
        if(showAddNewDialog){
        if(SecurityService.canUserAccess(props.Security)['List']){
          switch(props.Route){
             case 'DeliverySchedule':
                       return (
                         <div>
                           <FabricPurchaseContractDeliveryScheduleList
                     {...props.SelectedRow}
                     name={props.Security}
                     IsDialog={true}
                 ></FabricPurchaseContractDeliveryScheduleList>
                         </div>
                       )
                     break;
                     case 'YarnDeliverySchedule':
                       return (
                         <div>
                           <YarnPurchaseContractDeliveryScheduleList
                     {...props.SelectedRow}
                     name={props.Security}
                     IsDialog={true}
                 ></YarnPurchaseContractDeliveryScheduleList>
                         </div>
                       )
                     break;
                     case 'Projection':
                       return (
                         <div>
                  <ProjectionPlanning
                     selectedRow={props.SelectedRow}
                     name={props.Security}
                     IsDialog={true}
                 ></ProjectionPlanning>
                         </div>
                       )
                     case 'GetBills':
                       return (
                         <div>
                  <GetBills
                     selectedRow={props.SelectedRow}
                     name={props.Security}
                     IsDialog={true}
                     sendDetails={props.sendDetails}
                     Type={props.Type}
                 ></GetBills>
                         </div>
                       )
                 
                          default:
              return(
            <div className="returnlist" style={{textAlign:'center'}}> <SecureComponent name={props.Security} /> </div>
              )
              
          } 

        } 
        else {
          return (
            <div className="returnlist" style={{textAlign:'center'}}> <SecureComponent name={props.Security} /> </div>
          );
        }
        }
      };
    
      
      
    return (
        <div>
          {
            showAddNewDialog == true ?
      (<div className='App' id='targetElement'>
        <DialogComponent
            width={props.Width ?  props.Width : '1200px' }
            height={props.Height ?  props.Height : '1000px' }
            visible={showAddNewDialog}
            close={onClose}
            content={contentTemplate}
            isModal={true}
          
            showCloseIcon={true}
            header={header}
            footerTemplate = {footerTemplate}
            
            zIndex={784465}

          />
        </div>)
        :null}
      <ButtonComponent 
        style={
          {
            ...(props.Color && { color: props.Color }),
            ...(props.BgColor && { backgroundColor: props.BgColor,borderColor:props.BgColor }),
            textWrap:'wrap'
        }
        }
        title={props.Title}
        onClick={ (e) => {
        e.preventDefault();
        onAddNewClick(props.Route);
      }
      }
        >{props.Title}</ButtonComponent>
        </div>
    );
}

export default IrtizaDynamicListButtonDialog;

